import { Trans } from "react-i18next"

import util from "utils/utils"

export default function CommentReacted({ events, ownerIdea = { name: "Undefined" } }) {
  return (
    <Trans i18nKey="notifications.ideaCommentReacted">
      <b>{{ name: util.getEventNames(events) }}</b> reacted to your comment on the idea
      <b>{{ idea: ownerIdea.name }}</b>
    </Trans>
  )
}
